export default {
    products: [],
    product: null,
    status: null,
}